const { REACT_APP_URL, NODE_ENV } = process.env
console.log({ REACT_APP_URL, NODE_ENV })
let URL = "https://kothar-api-g2g0h2cmh7dvcma4.uaenorth-01.azurewebsites.net/v2";
let Business_URL = "https://fea4518e.kothar-bussiness-web.pages.dev";

if (NODE_ENV === "development") {
    // URL = "http://localhost:3000/v2";
    // Business_URL = "http://localhost:3002";
    URL = "https://kothar-api-g2g0h2cmh7dvcma4.uaenorth-01.azurewebsites.net/v2";
    Business_URL = "https://fea4518e.kothar-bussiness-web.pages.dev";
}

if (REACT_APP_URL === "dev") {
    URL = "https://kothar-api-g2g0h2cmh7dvcma4.uaenorth-01.azurewebsites.net/v2";
    Business_URL = "https://fea4518e.kothar-bussiness-web.pages.dev";
}

const BASE_URL = URL

export { BASE_URL, Business_URL };

